import { useState } from 'react';

export const useForm = (objetoInicial = {}) => {
    const [formulario, setFormulario] = useState(objetoInicial);

    // Serializa el formulario completo en un objeto (si se usa con un form submit)
    const serializar = (formulario) => {
        const formData = new FormData(formulario);
        const objetoCompleto = {};

        for (let [name, value] of formData) {
            objetoCompleto[name] = value;
        }

        return objetoCompleto;
    };

    // Manejo de envío del formulario
    const enviado = (e) => {
        e.preventDefault();
        const datosSerializados = serializar(e.target);
        setFormulario(datosSerializados); // Actualizamos el estado del formulario completo
    };

    // Manejo de cambios en los campos individuales del formulario
    const cambiado = ({ target }) => {
        const { name, value } = target;
        setFormulario({
            ...formulario,
            [name]: value
        });
    };

    return {
        formulario,
        enviado,
        cambiado
    };
};
